<template>
    <div class="classAndBookBox">
        <div class="classBox">
            <div class="banner"></div>
            <div class="classCon">
                <p>全部分类：</p>
                <div ref="classBox">
                    <ul ref="classList">
                        <li v-for="item in classList" :key="item.id" :class=" classAct == item.id ? 'act' : '' " @click="goClass(item)">
                            <p>{{ item.name }}</p>
                            <div></div>
                        </li>
                    </ul>
                    <div v-show="isShowMoreBtn" :class="isMore ? 'act' : ''" @click="getMore"></div>
                </div>
            </div>
        </div>
        <div class="bookBox">
            <div class="head">{{ actName }}：</div>
            <ul>
                <li v-for="(item, index) in bookList" :key="index" class="bookList_book_style" @click="goBook(item.id)" :title="item.name">
                    <dl>
                        <dt>
                            <img :src="item.cover" alt="">
                            <div>
                                <div></div>
                                <p>{{ item.plays }}</p>
                            </div>
                        </dt>
                        <dd>
                            <p>{{ item.name }}</p>
                            <p>{{ item.author }}</p>
                        </dd>
                    </dl>
                </li>
            </ul>
            <pager :total-page="totalPage" :initPage="pageNum" @go-page="goPageNum" v-if="isShowPager" />
        </div>
    </div>
</template>
<script>
import pager from './pager.vue'
export default {
    components: {
        pager
    },
    data() {
        return {
            bookList: [],
            classList: [],
            classAct: -1,
            isMore: false,
            pageNum: 1,
            totalPage: 1,
            actName: "",
            isShowPager: false,
            isShowMoreBtn: false
        }
    },
    computed: {

    },
    mounted (){
        let that = this;
        that.getClassList();
        that.isMore = (JSON.parse(sessionStorage.getItem("isMore")) ? true : false);
        if( that.$route.query.id ) {
            that.classAct = that.$route.query.id;
            that.actName = that.$route.query.name;
            that.classBook();
        }
    },
    destroyed() {
        // let that = this;
        sessionStorage.removeItem("code");
        sessionStorage.removeItem("ancestors");
    },
    methods: {
        getClassList() {
            let that = this;

            that.allApi.classList().then((resource) => {
                // console.log(resource.data);
                if( resource.data.code == 200 ) {
                    that.classList = resource.data.data;
                    if( that.classAct == -1 ) {
                        that.classAct = that.classList[0].id;
                        that.actName = that.classList[0].name;
                        that.classBook();
                    }
                    that.$nextTick(()=>{
                        if( that.classList.length <= 16 ){
                            that.isShowMoreBtn = false;
                            that.$refs.classBox.style.height = "120px";
                        }else{
                            that.isShowMoreBtn = true;
                            if( that.isMore ) {
                                that.$refs.classBox.style.height = that.$refs.classList.offsetHeight + "px";
                            }else{
                                that.$refs.classBox.style.height = "120px";
                            }
                        }
                    })
                }
            })
        },
        getMore() {
            let that = this;
            if( that.isMore ) {
                that.isMore = false;
                that.$refs.classBox.style.height = "120px";
                sessionStorage.setItem("isMore", that.isMore);
            }else {
                that.isMore = true;
                that.$refs.classBox.style.height = that.$refs.classList.offsetHeight + "px";
                sessionStorage.setItem("isMore", that.isMore);
            }
        },
        classBook() {
            let that = this;
            let data = {
                clazz: that.classAct,
                page: that.pageNum,
                size: 30
            }

            that.allApi.bookList(data).then((resource) => {
                // console.log(resource.data);
                if( resource.data.code == 200 ) {
                    that.bookList = resource.data.data.list;
                    that.totalPage = resource.data.data.pages;
                }
            })
        },
        goClass(item) {
            let that = this;
            that.$router.push({
                path: '/classBook',
                query: {
                    id: item.id,
                    name: item.name
                }
            });
            that.routerReload();
        },
        goPageNum(obj) {
            let that = this;
            that.pageNum = obj.page;
            that.classBook();
        },
        goBook(bookId) {
            let that = this;
            that.addClickNum(bookId);
            that.$router.push({
                path: '/book',
                query: {
                    id: bookId
                }
            })
        },
        addClickNum(bookId) {
            let that = this;
            let data = {
                book: bookId
            }
            that.allApi.bookClick(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    
                }
            })
        },
        routerReload() {
            let that = this;
            that.$store.commit("setIsRouterAlive", false);
            that.$nextTick(()=>{
                that.$store.commit("setIsRouterAlive", true);
            })
        },
    },
    watch: {
        totalPage(newV) {
            let that = this;
            if( newV == 1 ) {
                that.isShowPager = false;
            }else{
                that.isShowPager = true;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
// rgba(167,167,167,0.2)
    .classAndBookBox{
        width: 1200px;
        margin: 0 auto;
        >.classBox{
            box-shadow:0px 0px 7px 0px rgba(167,167,167,0.2);
            border-radius:6px;
            padding: 30px 62px;
            margin-bottom: 48px;
            >.banner{
                height: 74px;
                border-radius: 10px;
                margin-bottom: 20px;
                background-image: url('../assets/imgs/class/class_bg.png');
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }
            >.classCon {
                display: flex;
                >p{
                    font-size: 22px;
                    margin-right: 18px;
                }
                >div{
                    width: 0%;
                    flex: 1;
                    // height: 120px;
                    overflow: hidden;
                    position: relative;
                    transition: all .2s linear;
                    >ul{
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        >li{
                            padding: 0 10px;
                            font-size: 22px;
                            @include dominant_color(#1c1c1c);
                            cursor: pointer;
                            margin-right: 10px;
                            margin-bottom: 20px;
                            line-height: 40px;
                            position: relative;
                            &:hover,
                            &.act{
                                @include dominant_color_act(#1AA7E0);
                                >div{
                                    position: absolute;
                                    bottom: 0;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    border: 1px solid #1AA7E0;
                                    width: 30%;
                                }
                            }
                        }
                    }
                    >div{
                        position: absolute;
                        right: -0;
                        bottom: -0;
                        width: 21px;
                        height: 14px;
                        background: url("../assets/imgs/login/more_version_icon.png") center no-repeat;
                        cursor: pointer;
                        &.act{
                            transform: rotateZ(180deg)
                        }
                    }
                }
            }
        }
        >.bookBox{
            >.head{
                border-radius: 6px;
                height: 74px;
                background: #F7F7F7;
                line-height: 74px;
                padding: 0 30px;
                font-size: 20px;
                @include dominant_color(#1c1c1c);
                margin-bottom: 40px;
            }
            >ul{
                display: flex;
                flex-wrap: wrap;
                >li{
                    margin-right: 66px;
                    margin-bottom: 50px;
                    width: 145px;
                    &:nth-child(6n) {
                        margin-right: 0;
                    }
                }
            }
        }
    }
</style>
